<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/28tthX/e9781429989503_cover.jpg?1726444355374" alt="This image is the cover for the book End of East"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">End of East
      </h1>
      <p class="bookDescription body article font2">
        <p><i>In the tradition of Amy Tan and Jhumpa Lahiri, a moving portrait of three generations of family living in Vancouver's Chinatown</i><br/><br/>From Knopf Canada's New Face of Fiction program--launching grounds for Yann Martel's <i>Life of Pi</i> and Ann-Marie MacDonald's <i>Fall on Your Knees</i>--comes this powerfully evocative novel.<br/><br/>At age eighteen, Seid Quan is the first in the Chan family to emigrate from China to Vancover in 1913. Paving the way for a wife and son, he is profoundly lonely, even as he joins the Chinatown community.<br/><br/>Weaving in and out of the past and the present, <i>The End of East</i> pieces together the spellbinding tale of Seid Quan's family: his wife Shew Lin, whose hope for her family are threatened by her own misguided actions; his son Pon Man, who struggles with obligation and desire; his daughter-in-law Siu Sang, who tries to be the caregiver everyone expects, even as she feels herself unraveling; and his granddaughter Sammy, who finds herself embroiled in a volatile mixture of seduction, grief, and duty.<br/><br/>An exquisite debut of isolation, immigration, romance, and insanity, <i>The End of East</i> sets family conflicts against the backdrop of Vancouver's Chinatown--a city within a city where dreams are shattered as quickly as they're built, and where history repeats itself through the generations. It is a bold and accomplished debut from one of Canada's brightest new literary stars.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jen Sookfong Lee
      </h2>
      
      <p class="authorDescription body article"><P><B>Jen Sookfong Lee</B> was born and raised in Vancouver's East Side, where she now lives with her husband. Her poetry, fiction, and articles have appeared in a variety of magazines, including <I>The Antigonish Review</I>, <I>The Claremont Review</I>, <I>Horsefly</I>, and <I>Jasmine</I>. A finalist for the Stephen Leacock Poetry Contest, she is a Knopf Canada New Face of Fiction for <I>The End of East</I>.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?ce0cd1ce